import styles from '../styles/Home.module.css';
import { useState } from 'react';
import { Fade } from "react-awesome-reveal";
import { Link } from 'react-router-dom';

// Images
import logo from '../images/logo.png';
import whoImage from '../images/whoImage.png';
import sniwwoc from '../images/sniwwoc.png';
import magazine from '../images/magazine.png';
import milchee from '../images/milchee.png';
import designIconOne from '../images/design1.png';
import designIconTwo from '../images/design2.png';
import designIconThree from '../images/design3.png';
import qualityOne from '../images/quality1.png';
import qualityTwo from '../images/quality2.png';
import qualityThree from '../images/quality3.png';

// Data
import { skills } from '../data/skills';

// Components
import Footer from '../components/Footer';

export default function Home() {
  const [data, setData] = useState([...skills]);

  return (
    <>
      {/* Top */}
      <div className={styles.topContainer}>
        <Fade direction='down' triggerOnce={true}>
          <img className={styles.logo} src={logo} alt='logo'/>
          <p className={styles.name}>Andrea Wong</p>
        </Fade>
        <Fade triggerOnce={true}>
          <div className={styles.iconsContainer}>
            <a className={styles.githubIcons} href='https://github.com/Andreawz3' target="_blank">
              <i class="fa fa-github"></i>
            </a>
            <a className={styles.linkedinIcons} href='https://www.linkedin.com/in/andreawzh/' target="_blank">
              <i class="fa fa-linkedin-square"></i>
            </a>
          </div>
        </Fade>
        <Fade direction='up' triggerOnce={true}>
          <p className={styles.jobTitle}>Web Developer & Designer</p>
        </Fade>
      </div>
      {/* Who Am I */}
      <div className={styles.whoIAmContainer}>
        <Fade direction="left" triggerOnce={true}>
          <p className={styles.title}>Who Am I</p>
        </Fade>
        <Fade direction='right' triggerOnce={true}>
          <p className={styles.whoDescription}>
            I'm an enthusiastic open-minded, and fast-learning Web Developer & UX/UI Designer 
            dedicated to creating seamless digital experiences that blend innovation with user-centric design principles.
          </p>
          <img className={styles.whoImage} src={whoImage}/>
        </Fade>
      </div>
      {/* Projects */}
      <div className={styles.projectsContainer} id='projects'>
        <p className={styles.title}>Main Projects</p>
        <div className={styles.projectsDisplay}>
          <Fade cascade={false} delay={100} direction='up'>
            <div className={styles.cwhContainer}>
              <div className={styles.whiteOffBackground}>
                <div className={styles.projectsBorder}>
                  <p className={styles.projectsTitle}>CWH in B.C.</p>
                  <p className={styles.projectsDescription}>
                    An e-book to guide to the diverse ecosystems of British Columbia's Coastal Western Hemlock (CWH) zone.
                  </p>
                  <Link className={styles.projectsLink} to={"/cwh"}>
                    Explore <i class="fa fa-angle-double-right"></i>
                  </Link>
                </div>
              </div>
            </div>
          </Fade>
          <Fade cascade={false} delay={300} direction='up'>
            <div className={styles.spurtContainer}>
              <div className={styles.whiteOffBackground}>
                <div className={styles.projectsBorder}>
                  <p className={styles.projectsTitle}>Spurt App</p>
                  <p className={styles.projectsDescription}>
                    A go-to-app to manage community garden and start your plant journey.
                  </p>
                  <Link className={styles.projectsLink} to={"/spurt"}>
                    Explore <i class="fa fa-angle-double-right"></i>
                  </Link>
                </div>
              </div>
            </div>
          </Fade>
          <Fade cascade={false} delay={500} direction='up'>
            <div className={styles.yoriContainer}>
              <div className={styles.whiteOffBackground}>
                <div className={styles.projectsBorder}>
                  <p className={styles.projectsTitle}>Yori App</p>
                  <p className={styles.projectsDescription}>
                    A mobile web application cook-book that promotes a variety of healthy, affordable meals.
                  </p>
                  <Link className={styles.projectsLink} to={"/yori"}>
                    Explore <i class="fa fa-angle-double-right"></i>
                  </Link>
                </div>
              </div>
            </div>
          </Fade>
        </div>
      </div>
      {/* Graphic Designs */}
      <div className={styles.graphicContainer} id='designs'>
        <p className={styles.title}>Graphic Designs</p>
        <div className={styles.designsDisplay}>
          <Fade cascade={false} delay={100} direction='right'>
            <div>
              <img className={styles.designsImg} src={sniwwoc} />
              <div className={styles.desingInfo}>
                <img className={styles.designIcon} src={designIconOne} />
                <p className={styles.designTitle}>SNIWWOC Product Desings</p>
                <p className={styles.designDesc}>
                  A Canadian non-profit organization committed to empowering women. 
                  By providing resources such as education, advocacy, and community support.
                </p>
                <Link className={styles.designLink} to={"/sniwwoc"}>view more</Link>
              </div>
            </div>
          </Fade>
          <Fade cascade={false} delay={300} direction='right'>
            <div>
              <img className={styles.designsImg} src={magazine} />
              <div className={styles.desingInfo}>
                <img className={styles.designIcon} src={designIconTwo} />
                <p className={styles.designTitle}>Gaudí’s Masterpieces - Magazine</p>
                <p className={styles.designDesc}>
                In a captivating display of architectural mastery, 
                the magazine showcases the inspiring works of Antoni Gaudí.
                </p>
                <Link className={styles.designLink} to={"/gaudi-magazine"}>view more</Link>
                {/* <a className={styles.designLink} href='https://indd.adobe.com/view/4aa2ae1b-faab-4ba2-b777-253e661f1a77' target="_blank">view more</a> */}
              </div>
            </div>
          </Fade>
          <Fade cascade={false} delay={500} direction='right'>
            <div>
              <img className={styles.designsImg} src={milchee} />
              <div className={styles.desingInfo}>
                <img className={styles.designIcon} src={designIconThree} />
                <p className={styles.designTitle}>Milchee - Can Beverage</p>
                <p className={styles.designDesc}>
                  A milk can drink design that blends sleek minimalism with colorful imagery, 
                  highlighting its creamy texture and natural flavors.
                </p>
                <a className={styles.designLink} href='/milchee'>view more</a>
              </div>
            </div>
          </Fade>
        </div>
      </div>
      {/* Skills */}
      <div className={styles.skillsContainer}>
        <p className={styles.title}>Skills</p>
        <p style={{marginTop: '24px'}}>Skilled in design and development, blending creativity with technical expertise.</p>
        <div className={styles.skillDesc}>
          {
            data && data.map((d, index) => {
              return (
                <Fade  cascade={false} delay={index * 100} direction='bottom' triggerOnce={true}>
                  <div key={index} className={styles.skillInfo}>
                    <a className={styles.skillLink} href={d.url} target="_blank">
                      <img className={styles.skillIcon} src={d.image} alt={d.name} />
                    </a>
                  </div>
                </Fade>
              )
            })
          }
        </div>
      </div>
      {/* Work with Me */}
      <div className={styles.qualitiesContainer}>
        <p className={styles.title}>Why Work With Me</p>
        <p style={{marginTop: '24px'}}>My top three attributes include:</p>
        <div className={styles.qualitiesInfo}>
          <Fade cascade={false} direction='right'>
            <div className={styles.qualitiesDesc}>
              <img  className={styles.qualitiesImg} src={qualityOne} />
              <p className={styles.qualityTitle}>Attention to Detail</p>
              <p className={styles.qualityParagraph}>Precision in coding and design to ensure a seamless user experience</p>
            </div>
          </Fade>
          <Fade delay={300}>
            <div className={styles.qualitiesDesc}>
              <img  className={styles.qualitiesImg} src={qualityTwo} />
              <p className={styles.qualityTitle}>Communication Skills</p>
              <p className={styles.qualityParagraph}>Clear communication with clients and team members to understand and meet requirements</p>
            </div>
          </Fade>
          <Fade cascade={false} direction='left'>
            <div className={styles.qualitiesDesc}>
              <img  className={styles.qualitiesImg} src={qualityThree} />
              <p className={styles.qualityTitle}>Continuous Learning</p>
              <p className={styles.qualityParagraph}>Commitment to ongoing learning and professional development</p>
            </div>
          </Fade>
        </div>
      </div>
      {/* Footer */}
      <Footer />
    </>
  )
}